export default function () {
	return {
		init() {
			this.validate()
		},

		validate() {
			window.addEventListener('load', () => {
				document
					.querySelectorAll(
						'.validate-required input, .validate-required select',
					)
					.forEach((element) => {
						if (element.value) {
							element.dispatchEvent(new Event('validate', { bubbles: true }))
						}
					})
			})
		},
	}
}
